import { render, staticRenderFns } from "./UserDetailPositionTable.vue?vue&type=template&id=c23ecf2c&scoped=true&"
import script from "./UserDetailPositionTable.vue?vue&type=script&lang=js&"
export * from "./UserDetailPositionTable.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailPositionTable.vue?vue&type=style&index=0&id=c23ecf2c&lang=scss&scoped=true&"
import style1 from "./UserDetailPositionTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23ecf2c",
  null
  
)

export default component.exports